import { render, staticRenderFns } from "./Additional-Documents.vue?vue&type=template&id=557c7004&scoped=true"
import script from "./Additional-Documents.vue?vue&type=script&lang=js"
export * from "./Additional-Documents.vue?vue&type=script&lang=js"
import style0 from "./Additional-Documents.vue?vue&type=style&index=0&id=557c7004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c7004",
  null
  
)

export default component.exports